import React, { useCallback } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { createLocale } from 'locales';

import VideoPreview from 'components/video-preview';

import Typography from 'components-new/typography/typography';
import Button from 'components-new/button/button';

import { STATIC_FILES_URL } from 'constants/signup-flow-constants';

import useGetFreelancerPersonRegisterDocument from 'state/remote/remote-freelancer/use-get-freelancer-person-register-document';

import FreelancerSignUpPageContainer from '../components/freelancer-sign-up-page-container';

import DocumentInstructions from '../components/DocumentInstructions';

import freelancerRoutes from '../freelancer-routes';

const localize = createLocale('freelancerDocumentsInformationPageLocales');

const DocumentsInformation: React.FC = () => {
  const navigate = useNavigate();
  const setSearchParams = useSearchParams({})[1];

  const { document } = useGetFreelancerPersonRegisterDocument();

  const videoUrl = `${STATIC_FILES_URL}videos/signupflow/h4.mp4`;
  const videoPreviewImageURL = `${window.STATIC_URL}assets/signupflow/h4.png`;

  const goToFillInfoPage = useCallback(() => {
    navigate(freelancerRoutes.fillInformation.path);
  }, [navigate]);

  const goToPersonelRegisterPage = useCallback(() => {
    navigate(
      `${freelancerRoutes.personRegister.path}?showVideoInstructions=true`,
    );
  }, [navigate]);

  const showInstructions = useCallback(() => {
    setSearchParams({ showInstructionDialog: 'true' });
  }, [setSearchParams]);

  return (
    <FreelancerSignUpPageContainer
      headerTitle={localize('title')}
      showHeader
      showGoBackButton
      onGoBackClick={goToFillInfoPage}
      dialogInstructions={{
        component: <DocumentInstructions />,
        shouldShowDialogInstructions: !document,
      }}
      videoInstructions={{
        url: videoUrl,
        videoPreviewImageURL,
      }}
    >
      <Typography
        as="p"
        variant="body-medium"
        className="mt-4 w-full text-gray500"
      >
        {localize('helperMessage')}
      </Typography>
      <VideoPreview
        videoURL={videoUrl}
        videoPreviewImageURL={videoPreviewImageURL}
      />
      <Typography
        as="h3"
        variant="body-large"
        className="w-full mt-6 text-center"
      >
        {localize('preferToreadInstructions')}{' '}
        <button onClick={showInstructions} type="button">
          <b className="text-purple">{localize('thenClickHere')}</b>
        </button>
      </Typography>
      <Button
        variant="primary"
        label={localize('startDocs')}
        className="h-10 py-2 px-4 w-full my-10 flex items-center justify-center"
        onClick={goToPersonelRegisterPage}
      />
    </FreelancerSignUpPageContainer>
  );
};

export default DocumentsInformation;
